import React from 'react';
import { Grid, Link } from '@material-ui/core';
import { Typography } from '@totango-app-team/ui-shared-components';
import PropTypes from 'prop-types';

import './check-email.step.less';

export default function CheckEmailStep({ email }) {
	return (
		<Grid
			container
			spacing={3}
			className="step-container email-validation create-account check-email-step"
		>
			<Grid item xs={12}>
				<h5 className="step-title" align="center">
					Check your email!
				</h5>
			</Grid>
			<Grid item xs={12} className="check-your-email-img-container">
				<img src="/img/self-service/mail-icon.svg" alt="check your email" />
			</Grid>
			<Grid item xs={12}>
				<Typography variant="subtitle2" className="sent-email-text">
					We sent an email to
					<br />
					<strong>{email}</strong>
					<br />
					to confirm your email address and access
					<br />
					your new account.
				</Typography>
			</Grid>

			<Grid item xs={12}>
				<div className="having-trouble">
					This could take a couple of minutes depending on your email service.
					<br />
					{"Still didn't get the email? "}
					<Link
						href="mailto:support@totango.com?subject=Please send me a link to Totango"
						style={{ cursor: 'pointer' }}
						className="verify-email-link"
					>
						{'  '}
						Verify by sending us an email
					</Link>
				</div>
			</Grid>
		</Grid>
	);
}

CheckEmailStep.propTypes = {
	email: PropTypes.string.isRequired,
};
